<label class="telenet-radio-button">
   <input data-testid="telenet-radio-input" class="telenet-radio-button-input" type="radio" [value]="value" [ngModel]="ngModel" (ngModelChange)="onModelChange($event)" [disabled]="disabled" />
   <div class="telenet-radio-button-custom" [class.checked]="ngModel" [class.disabled]="disabled">
      @if (ngModel) {
         <span class="checkmark"></span>
      }
   </div>
   <label class="telenet-radio-button-label" [class.disabled]="disabled">
      <ng-content></ng-content>
   </label>
</label>
